import ModelTypeConstants from 'constants/ModelTypeConstants';
import {previewPlugin} from 'notebook/notes/previews/PreviewPluginFactory';

import ProteinPreview from './ProteinPreview';

const PROTEIN_PREVIEW_PLUGIN = previewPlugin({
  type: ModelTypeConstants.PROTEIN,
  preview: ProteinPreview,
});

export default PROTEIN_PREVIEW_PLUGIN;
